import CheckableButton from './CheckableButton';
import SmallUserCard from './SmallUserCard';
import LeaderBoardList from './LeaderBoardList';
import LeaderBoardListItem from './LeaderBoardListItem';
import LeaderBoardPage from './LeaderBoardPage';
import LeaderBoardUserCard from './LeaderBoardUserCard';

export const components = {
  CheckableButton,
  SmallUserCard,
  LeaderBoardList,
  LeaderBoardListItem,
  LeaderBoardPage,
  LeaderBoardUserCard,
};
